import { QueryClient } from '@tanstack/react-query';
import equal from 'fast-deep-equal';
import { addLogoutHandler } from 'helpers/auth/auth-handlers';
import { QueryFactory } from 'services/api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      structuralSharing: (oldData: any, newData) =>
        equal(oldData, newData) ? oldData : newData,
      refetchOnWindowFocus: false,
      throwOnError: true,
      // retries are configured at axios level
      retry: false,
    },
  },
});

addLogoutHandler(() => {
  // this is to make `useIsAuthorized` hook rerender, return false, and log the user out
  queryClient.setQueryData(
    QueryFactory.UserQuery.getCurrentUserInfoQueryKey(),
    null,
  );
});

export async function invlidateAuthQuery() {
  await queryClient.invalidateQueries({
    queryKey: QueryFactory.UserQuery.getCurrentUserInfoQueryKey(),
  });
}
